// src/lib/queryClient.ts

import { QueryClient } from '@tanstack/react-query';

/**
 * 全局 TanStack Query 客户端配置
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 默认查询选项
      refetchOnWindowFocus: false, // 窗口聚焦时不自动重新获取
      retry: 1,                   // 失败时重试 1 次
      staleTime: 30 * 1000,       // 30 秒内数据视为新鲜
      gcTime: 5 * 60 * 1000,      // 5 分钟后垃圾回收
      throwOnError: false,        // 错误由 UI 层处理，不抛出异常
    },
    mutations: {
      // 默认 Mutation 选项
      retry: 0,                   // Mutation 不重试（避免重复提交）
      throwOnError: false,        // 错误由 UI 层处理
    },
  },
});